import React, { useRef } from 'react';
import { RecaptchaRef } from 'components/Recaptcha';
import PremiumBuyerSubscriptionContext from './PremiumBuyerSubscription.context';

type PremiumBuyerSubscriptionProps = {
  children?: React.ReactNode;
};

const PremiumBuyerSubscription: React.FC<PremiumBuyerSubscriptionProps> = (
  props,
) => {
  const { children } = props;

  const recaptchaRef = useRef<RecaptchaRef>(null);

  return (
    <PremiumBuyerSubscriptionContext.Provider
      value={{
        recaptchaRef,
      }}
    >
      {children}
    </PremiumBuyerSubscriptionContext.Provider>
  );
};

export default PremiumBuyerSubscription;
